import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

/* Register the service worker so IVEM can be installed as an app and can
   badge its icon with unread messages. It caches nothing, so a new deploy
   is always live on the next load. Skipped on localhost during development. */
if ("serviceWorker" in navigator && window.location.hostname !== "localhost") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      /* unsupported browser or blocked — the portal works the same without it */
    });
  });
}
